export default __webpack_public_path__ + "static/media/interface-9.1cee5f2c.png";